import {
  _setNonCompliantOnly,
  _setSelectedSsaStudent,
  _setSelectedStudentsList,
  _setSelectedMultipleStudents,
  _setSelectedSsaStudentDetails,
  _setSelectedStudentHeadingDetails,
} from './ssaStudentDetailAction';
import { createSlice } from '@reduxjs/toolkit';
import initialState from './ssaStudentDetailInitialState';

export const ssaStudentDetailSlice = createSlice({
  name: 'delta/SSAStudentDetail',
  initialState: initialState,
  reducers: {
    setNonCompliantOnly: _setNonCompliantOnly,
    setSelectedSsaStudent: _setSelectedSsaStudent,
    setSelectedStudentsList: _setSelectedStudentsList,
    setSelectedMultipleStudents: _setSelectedMultipleStudents,
    setSelectedSsaStudentDetails: _setSelectedSsaStudentDetails,
    setSelectedStudentHeadingDetails: _setSelectedStudentHeadingDetails,
  },
});

export const {
  setNonCompliantOnly,
  setSelectedSsaStudent,
  setSelectedStudentsList,
  setSelectedMultipleStudents,
  setSelectedSsaStudentDetails,
  setSelectedStudentHeadingDetails,
} = ssaStudentDetailSlice.actions;

export default ssaStudentDetailSlice.reducer;
